import { createStore, applyMiddleware } from "redux";
import rootReducer from "./Reducer";
import thunk from 'redux-thunk';
import initialState from './State';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

// Load the persistent state from localStorage
let state = {
    ...initialState,
};

const persistConfig = {
    key: 'root',
    storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

//export const Store = createStore(reducer, {}, applyMiddleware(thunk));
export const Store = createStore(persistedReducer, {}, applyMiddleware(thunk));
export const Persistor = persistStore(Store);